<template>
  <!-- 订单详情  -->
  <Modal v-model="visible" title="订单详情" :footer-hide="true" width="1100" class="my-modal top">
    <Tabs v-model="type" :animated="false" style="padding-top: 10px">
      <TabPane label="投保信息" name="1">
        <my-form :formList="insurebase" :span="8" class="detail"></my-form>
      </TabPane>
      <TabPane label="被保险人及保障权益" name="2">
        <interests :obj="detailInfo" :operationFunction= "operationFunction" />
      </TabPane>
      <!-- <TabPane label="续期信息" name="3">
        <renewal :obj="detailInfo" />
      </TabPane>
      <TabPane label="结算记录" name="4">
        <record :obj="detailInfo" />
      </TabPane>-->
    </Tabs>
  </Modal>
</template>

<script>
import myForm from "@/components/commons/form";
import interests from "./interests";
import insurebase from "../form/insurebase";
// import renewal from "./renewal";
// import record from "./record";
import { getOrdeDetail } from "@/api/httpList";
export default {
  components: {
    myForm,
    interests,
    // renewal,
    // record,
  },
  props: ['operationFunction'],
  data() {
    return {
      visible: false,
      type: "1",// 当前tab
      insurebase: [], //投保信息
      detailInfo: {}, //详情数据
    };
  },
  watch: {},
  computed: {},
  methods: {
    async open(row) {
      this.$notice.showLoading();
      let res = {};
      try {
        res = await getOrdeDetail(row.orderNo);
      } catch (error) {
        console.log(error)
        return;
      } finally {
        this.$notice.hideLoading();
      }
      this.visible = true;
      this.type = '1';

      const obj = {
        orgName: row.orgName,
        groupName: row.groupName,
        salesmanName: row.salesmanName,
        operationFunction:row.operationFunction ||this.operationFunction
      };
      this.detailInfo = Object.assign(res.data, obj);
      //回填基本信息
      this.insurebase = insurebase(this, row.status, this.detailInfo, row);
      this.insurebase[0].data.forEach((item) => {
        for (let key in res.data) {
          if (item.key == key) {
            item.value = res.data[key];
          }
          if (!item.value) {
            item.value = "-";
          }
        }
      });
      //投保人信息
      this.insurebase[1].data.forEach((item) => {
        for (let key in res.data.holder) {
          if (item.key == key) {
            item.value = res.data.holder[key];
          }
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
</style>